// ****IMPORTANT****
// "Will I get to see my results or feedback after the test?" this question should be last one as we are slicing the last question for some orgs
import orgBasedFeatureNameMapping from "@assessment/utils/orgBasedFeatureName";
import { TFunction } from "i18next";

export interface StructuredAnswer {
  firstSentence?: string;
  list?: string[];
  lastSentence?: string;
}

export interface FaqQuesAndAnsData {
  question: string;
  answer: (string | StructuredAnswer)[];
}

export const getFaqData = (
  orgName: string = "gl-india",
  t: TFunction
): FaqQuesAndAnsData[] => {
  // Determine terminology: Hitachi uses "Knowledge Check", others use "Assessment"
  const orgBasedFeatureName =
    orgBasedFeatureNameMapping[orgName] ||
    orgBasedFeatureNameMapping.default ||
    "Assessment";
  const featureName = orgBasedFeatureName?.toLowerCase();

  return [
    {
      question: t("assessment.faq.q1.question", { featureName }),
      answer: [
        { firstSentence: t("assessment.faq.q1.firstSentence") },
        {
          list: [
            t("assessment.faq.q1.list.item1"),
            t("assessment.faq.q1.list.item2"),
            t("assessment.faq.q1.list.item3"),
            t("assessment.faq.q1.list.item4"),
            t("assessment.faq.q1.list.item5")
          ]
        }
      ]
    },
    {
      question: t("assessment.faq.q2.question", { featureName }),
      answer: [
        { firstSentence: t("assessment.faq.q2.firstSentence") },
        {
          list: [
            t("assessment.faq.q2.list.item1"),
            t("assessment.faq.q2.list.item2")
          ]
        },
        {
          lastSentence: t("assessment.faq.q2.lastSentence", { featureName })
        }
      ]
    },
    {
      question: t("assessment.faq.q3.question"),
      answer: [
        {
          list: [
            t("assessment.faq.q3.list.item1", { featureName }),
            t("assessment.faq.q3.list.item2")
          ]
        }
      ]
    },
    {
      question: t("assessment.faq.q4.question"),
      answer: [
        { firstSentence: t("assessment.faq.q4.firstSentence") },
        {
          lastSentence: t("assessment.faq.q4.lastSentence", { featureName })
        }
      ]
    },
    {
      question: t("assessment.faq.q5.question"),
      answer: [
        {
          firstSentence: t("assessment.faq.q5.firstSentence", { featureName })
        },
        {
          list: [
            t("assessment.faq.q5.list.item1"),
            t("assessment.faq.q5.list.item2")
          ]
        }
      ]
    }
  ];
};
